import type { TabCardItemProps } from "@op/puck-types";
import { slug } from "@op/utils";
import { Content } from "@radix-ui/react-tabs";
import { useMemo } from "react";

const TabCardItem = ({ title, children }: TabCardItemProps) => {
  const value = useMemo(() => slug(title), [title]);

  return <Content value={value}>{children}</Content>;
};

export default TabCardItem;
